import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {NavigationTabsModuleConfig} from "./navigation-tabs-module.config";
import {NavigationTabsModuleStore} from "./navigation-tabs-module.store";
import {NavigationTabsModuleHandlers} from "./handlers/navigation-tabs-module.handlers";

export class NavigationTabsModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, NavigationTabsModuleConfig, NavigationTabsModuleStore, NavigationTabsModuleHandlers];
}
